"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavigationEntryAllOfToJSON = exports.NavigationEntryAllOfFromJSONTyped = exports.NavigationEntryAllOfFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function NavigationEntryAllOfFromJSON(json) {
    return NavigationEntryAllOfFromJSONTyped(json, false);
}
exports.NavigationEntryAllOfFromJSON = NavigationEntryAllOfFromJSON;
function NavigationEntryAllOfFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'subEntries': !(0, runtime_1.exists)(json, 'subEntries') ? undefined : (json['subEntries'].map(_1.NavigationEntry2FromJSON)),
    };
}
exports.NavigationEntryAllOfFromJSONTyped = NavigationEntryAllOfFromJSONTyped;
function NavigationEntryAllOfToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'subEntries': value.subEntries === undefined ? undefined : (value.subEntries.map(_1.NavigationEntry2ToJSON)),
    };
}
exports.NavigationEntryAllOfToJSON = NavigationEntryAllOfToJSON;
//# sourceMappingURL=NavigationEntryAllOf.js.map